import { useMemo } from "react";
import { useAlarmButtonTypes } from "./useEvacuationData";

interface UseAlarmTypeLabelResult {
  label: string;
  isLoading: boolean;
}

export const useAlarmTypeLabel = (
  emergencyType: string | undefined
): UseAlarmTypeLabelResult => {
  const { data: alarmTypes, isLoading } = useAlarmButtonTypes();

  const label = useMemo(() => {
    if (!alarmTypes || !emergencyType) return emergencyType || "";
    const found = alarmTypes.find((t) => t.value === emergencyType);
    return found?.label || emergencyType;
  }, [alarmTypes, emergencyType]);

  return { label, isLoading };
};
